export const GRAPH_NODE_ID = 'data-graph-node-id';
export const GRAPH_EDGE_ID = 'data-graph-edge-id';
